<template>
  <div>
    <div class="full-screen" @click="handleFullscreen">
      <img v-if="isFullscreen" src="../assets/img/icon-exit-fullscreen.png" alt="">
      <img v-else src="../assets/img/icon-full.png" alt="">
    </div>
    <div id="impress"
         data-transition-duration="1000"
         data-width="4096"
         data-height="2160"
         data-max-scale="3"
         data-min-scale="0"
         data-perspective="1000"
         data-autoplay="0">
      <div id="banner" class="step" data-x="-4096" data-y="0" data-z="0">
        <firstBanner @pageNext="goNext"/>
      </div>
      <div id="country" class="step" data-x="0" data-y="0" data-z="-2000">
        <country @prev="prev" @pageNext="goNext"/>
      </div>
      <div id="qinhuangdao" class="step" data-x="4096" data-y="0" data-z="-3000">
        <county v-if="curCounty" @prev="prev"></county>
        <qinhuangdao v-else @prev="prev" @next="next"></qinhuangdao>
      </div>
      <div id="events" class="step stop" data-x="10000" data-y="0" data-z="-4000">
        <events @prev="prev"></events>
      </div>
<!--      <div id="county" class="step" data-x="5760" data-y="0">-->
<!--      </div>-->
    </div>
<!--    <el-button v-if="!$route.hash.includes('banner')" class="go-back" type="text" @click="goBack">-->
<!--      <i class="el-icon-back"></i>返回-->
<!--    </el-button>-->
<!--    <el-button class="go-next" type="text" @click="goNext">-->
<!--      <i class="el-icon-right"></i>进入-->
<!--    </el-button>-->
  </div>
</template>
<script>
import screenfull from 'screenfull'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      impressApi: null,
      isFullscreen: screenfull.isFullscreen
    }
  },
  components: {
    firstBanner: () => import('./banner.vue'),
    country: () => import('./country.vue'),
    qinhuangdao: () => import('./qinhuangdao.vue'),
    events: () => import('./events.vue'),
    county: () => import('./county.vue')
  },
  computed: {
    ...mapState({
      curCounty: (state) => state.page.curCounty,
    }),
  },
  mounted () {
    const vm = this
    this.$nextTick(()=> {
      vm.init()


      screenfull.on('change', () => {
        this.isFullscreen = screenfull.isFullscreen
      })
    })
  },
  methods: {
    init () {
      const vm = this
      var rootElement = document.getElementById( "impress" );
      rootElement.addEventListener( "impress:init", function(event) {
        // console.log(event)
        vm.impressApi = event.detail.api
        window.vm = vm
            // console.log( "Impress init" );
      });
      // eslint-disable-next-line no-undef
      impress().init();
      // document.addEventListener('impress:stepenter', function (event) {
      //   console.log(vm.impressApi.getCurrentStep())
      // })
      // document.addEventListener('touchmove', function(e) {
      //   e.preventDefault(); // 这可能会影响滚动
      // });
    },
    next () {
      debugger
      console.log('next')
      // eslint-disable-next-line no-undef
      impress().next()
    },
    prev () {
      // eslint-disable-next-line no-undef
      impress().prev();
    },
    goBack () {
      this.prev()
    },
    goNext () {
      this.next()
    },
    handleFullscreen () {
      this.isFullscreen = screenfull.isFullscreen
      if (!screenfull.isFullscreen) {
        screenfull.request()
      } else {
        screenfull.exit()
      }
    }
  }
}
</script>
<style lang="scss">
@import "~/src/assets/css/common.scss";
.full-screen{
  position: fixed;
  right: 14px;
  top: 36px;
  width: 20px;
  height: 20px;
  z-index: 9999;
  cursor: pointer;
  img{
    width: 100%;
    height: 100%;
  }
}
#impress{
  transform: scale(1) !important;
  perspective: unset !important;
}
.go-back{
  position: fixed;
  left: 50px;
  bottom: 50px;
  z-index: 9;
  font-size: 24px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 36px;
}
</style>
